import { Card } from 'react-bootstrap';
import { Component } from 'react';

class CardComponent extends Component {
    render() {
        return (
            <div className="musashi-card">
                <Card>
                    <Card.Img variant="top" src="/images/Alejandro_Villaparedes_Quiroz.jpeg" alt="Alejandro Villaparedes Quiroz" decoding="async" loading="lazy" />
                    <Card.Body>
                        <Card.Title>Alejandro Villaparedes Quiroz</Card.Title>
                        <Card.Text>
                            Fundador y profesor líder de MUSASHI cinta negra II dan
                        </Card.Text>
                    </Card.Body>
                </Card>
            </div>
        );
    }
}

export default CardComponent;
